import React from "react"
import ImageWithTitle from "./ImageWithTitle"
import utilsCSS from "./utils.module.css"
import css from "./SinglePortraitImageWithTitle.module.css"

export default function SinglePortraitImageWithTitle({ ...props }) {
  return <div className={utilsCSS.centerWithFlex}>
    <ImageWithTitle {...props} className={css.portraitImage}/>
  </div>
}